module.exports = __webpack_public_path__ + "static/img/hysteroscope-1.91272de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hysteroscopepic/hysteroscope-1.jpg
// module id = wzXE
// module chunks = 51